import React from 'react';
import styled from 'styled-components';
import { Container, Store, Wrapper, wrap } from 'AppReact';
import { Title, Tab } from './atoms';
import { DotSvg } from 'components/icons';
import pageWrapper from './pageWrapper';
import { tabs, tabsArray } from './../../constants';
import { isEditMode } from '../../utils';


const checkErrors = (tabs, tab, fullState) => {
  const stateName = tab.id
  const state = fullState[stateName]

  if (Array.isArray(state)) {
    const hasError = state.some((item) => item.hasError)
    return hasError
  }

  if (stateName === "uploadedDoc") {
    const hasError = fullState.photoIDs.some((photo) => photo.hasError)
    if (!isEditMode() && hasError) return hasError
  }

  return !!state?.hasError
}


const getColor = (tabs, tab, selectedTabId, fullState) => {
  const isError = checkErrors(tabs, tab, fullState)
  if (isError) return 'red'
  if (tabs.indexOf(selectedTabId) >= tabs.indexOf(tab.id)) return window?.settins?.primary_color ?? "#1DBD6B" //green color

  return "#E3E3E3" //grey color
}



const PageTabs = Container({
  name: 'PageTabs',
  props: {
    tabs, property: Store, selectedTabId: Store, occupants: Store, moveInInformation: Store, pets: Store,
    vehicles: Store, currentResidency: Store, employmentInformations: Store, emergencyContacts: Store, uploadedDoc: Store,
    photoIDs: Store,
  },
  renderIf: ({ selectedTabId }) => {
    const showTabs = selectedTabId !== "landingPage" && selectedTabId !== "thankyouPage"
    return showTabs
  },
  elements: [
    {
      wrapper: pageWrapper,
      name: "Wrapper",
      elements: [
        {
          component: Title,
          name: 'Title',
          displayValue: ({ property }) => property?.name,
          renderIf: ({ property }) => !!property?.name,
        },
        {
          wrapper: Wrapper(styled.div`display:flex; justify-content: center;`),
          name: 'TabsFilter',
          elements: [
            {
              component: Tab,
              name: 'Tab',
              isListOf: 'tabs',
              bindings: ({ tab, selectedTabId, photoIDs }) => {
                return ({ selectedTabId, tab, selected: tab.id === selectedTabId, photoIDs })
              }
              ,
              displayValue: ({ indicatorColor, tab, selectedTabId, ...state }) => {
                const color = getColor(tabsArray, tab, selectedTabId, state)
                return <DotSvg color={color} selected={tab.id === selectedTabId} />
              },
            },
          ],
        },
      ]
    },
  ]
})

export default PageTabs;
